<template>
  <div id="app">
    <div class="loginPanel">
      <div style="text-align:center;">
        <img src="../../assets/sys_title.png" class="xboot-logo" />
      </div>
      <Divider />
      <Form ref="formValidate" :model="loginInfoVo" :rules="ruleValidate" label-position="top">
        <FormItem label="用户名" prop="loginid">
          <Input v-model="loginInfoVo.loginid" prefix="ios-contact-outline"></Input>
        </FormItem>
        <FormItem label="密码" prop="password">
          <Input
            v-model="loginInfoVo.password"
            prefix="ios-lock-outline"
            type="password"
            @on-enter="handleSubmit('formValidate')"
          ></Input>
        </FormItem>
        <FormItem>
          <Button
            :loading="loading"
            :style="{marginTop:'20px'}"
            type="success"
            @click="handleSubmit('formValidate')"
            long
            size="large"
            icon="md-log-in"
          >登录到平台</Button>
        </FormItem>
      </Form>
    </div>
  </div>
</template>

<script>
import crypto from "crypto";
let Base64 = require("js-base64").Base64;

export default {
  data() {
    return {
      redirect_code: this.$route.query.redirect_code,
      loginInfoVo: {
        loginid: "",
        password: "",
      },
      ruleValidate: {
        loginid: [{ required: true, message: "请填写账号", trigger: "blur" }],
        password: [{ required: true, message: "请填写密码", trigger: "blur" }],
      },
      loading: false,
    };
  },
  methods: {
    accountAsk() {
      this.$Modal.info({
        title: "提示",
        content: "请使用您的OA账号登录平台",
      });
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.login();
        }
      });
    },
    login() {
      this.loading = true;
      let loginid = this.loginInfoVo.loginid;
      let password = this.loginInfoVo.password;
      password = crypto.createHash("sha1").update(password).digest("hex");
      let _this = this;
      this.$http.post({
        method: "oasys/loginv2",
        params: {
          username: loginid,
          password: password,
        },
        success: function (data) {
          _this.loading = false;
          localStorage.token = data.token;
          localStorage.photourl = data.photourl;
          _this.$axios.defaults.headers.common["Authorization"] = data.token;
          _this.$router.replace("/dashboard");
          // if (_this.redirect_code != undefined) {

          //   let redirect_url = Base64.decode(_this.redirect_code);
          //   alert(redirect_url)
          //   if(redirect_url === undefined){
          //     _this.$router.replace("/projectall");
          //   }
          //   _this.$router.replace(redirect_url);
          // } else {
          //   _this.$router.replace("/projectall");
          // }
        },
        failure(code, msg) {
          _this.loading = false;
          _this.$Modal.error({
            title: "提示",
            content: msg,
          });
        },
      });
    },
  },
  mounted() {
    if (localStorage.token != undefined && localStorage.token.length > 0) {
      this.$router.replace("/dashboard");
    }
  },
};
</script>

<style>
body {
  background: #f8f8f9;
}

.control {
  margin-bottom: 15px;
}

.loginPanel {
  padding: 30px;
  padding-top: 80px;
  top: 20px;
  width: 400px;
  height: 500px;
  background: white;
  box-shadow: 0 1px 1px lightgray;
  margin-left: auto;
  margin-right: auto;
  margin-top: 50px;
  border-radius: 5px;
}

.login-panel {
  text-align: center;
  margin: auto;
  background: white;

  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 350px;
  height: 400px;
  position: absolute;
  box-shadow: lightgray 0px 0px 0.5px;
}

.input-bg {
  background: #faffbd;
}

.xboot-logo {
  height: 21px;
}

.xboot-title {
  font-size: 20px;
  vertical-align: middle;
  margin-left: 5px;
  font-weight: bold;
}
</style>

